import requestOptions from './requestOptions'
import { logError } from '../../logs/ErrorLoger'

/**
 * Envía la solicitud de registro de prueba gratuita al proxy PHP,
 * que a su vez llama al backend de EasyBuy con el X-Cron-Token server-side.
 *
 * @param {Object} formData  Datos del formulario ya normalizados.
 * @returns {Object}  { error, status, data?, fieldErrors?, message, variant }
 */
const registerTenant = async (formData) => {
  try {
    const options = requestOptions.options('POST', '', formData)
    const resp = await fetch(global.EASYBUY_REGISTER, options)

    let json = null
    try {
      json = await resp.json()
    } catch {
      // body vacío o no-JSON
    }

    // 201 — éxito
    if (resp.status === 201) {
      return {
        error: false,
        status: 201,
        data: json?.data ?? null,
        message: '¡Listo! Revisa tu correo para activar tu cuenta.',
        variant: 'success',
      }
    }

    // 409 — empresa/código duplicado
    if (resp.status === 409) {
      return {
        error: true,
        status: 409,
        message: 'Ya existe una empresa con ese código o correo.',
        variant: 'warning',
      }
    }

    // 422 — errores de validación con detalle por campo
    if (resp.status === 422) {
      const fields = json?.error?.details?.fields ?? {}
      return {
        error: true,
        status: 422,
        fieldErrors: fields,
        message: json?.error?.message ?? 'Revisa los datos ingresados.',
        variant: 'warning',
      }
    }

    // 429 — límite de peticiones
    if (resp.status === 429) {
      return {
        error: true,
        status: 429,
        message: 'Demasiados intentos. Espera un momento e intenta de nuevo.',
        variant: 'warning',
      }
    }

    // Cualquier otro error
    return {
      error: true,
      status: resp.status,
      message: 'Error al registrar, intenta de nuevo.',
      variant: 'error',
    }
  } catch (err) {
    await logError(err.message, 2)
    return {
      error: true,
      status: 0,
      message: global.GLOBAL_ERROR,
      variant: 'error',
    }
  }
}

const easyBuyServices = { registerTenant }
export default easyBuyServices
